<script setup>

</script>

<template>

  <main>
    <router-view/>
  </main>

</template>

<style scoped>

</style>
